import React from 'react';
import FeaturedAuthorTutoring from '../FeaturedAuthorTutoring';

import imageSrc from './orion.jpg';

const OrionTutoring = () => {
  return (
    <FeaturedAuthorTutoring
      imageSrc={imageSrc}
      description="Want to take your GRE score to the next level? Book a remote private tutoring session with Orion,
      author of the Achievable GRE manual and creator of the Stellar method. With over fifteen years of
      experience and a perfect score on the test, Orion has helped thousands of students hit their target scores
      and gain admission to top-ranked post-graduate programs. So whether you need to start from square
      one or just want to tweak an already finely-tuned system, who better to help you than the guy who
      wrote the book on the subject? Special discounts available for Achievable students."
      url="https://www.stellargre.com/?utm_source=achievable"
      cta="Visit Orion's site"
    />
  );
};

export default OrionTutoring;
